export const transferState = "TRANSFER";
export const errorState = "ERROR";
export const successState = "SUCCESS";
export const declinedState = "DECLINED";
